/**
 * 各伺服器 DB 缺少本地化名稱的 race 手動覆蓋表。
 * KR 通常有完整資料，故不需要在此補充。
 * 格式: { [lang]: { [raceId]: displayName } }
 */
export const RACE_OVERRIDES: Record<string, Record<number, string>> = {
    tw: {
        7615: '雷楠的米勒 : 悔恨',
    },
    cn: {
        7615: '雷内恩的米耶尔：悔恨',
    },
    jp: {
        7615: 'レネンのミイル：悔恨',
    },
    us: {
        7615: 'Midir the Lost',
    },
};
